<template>
  <div class="modal-card" v-if="resource">
    <header class="modal-card-head">
      <div>
        <h3>{{ resource.title }}</h3>
      </div>
    </header>
    <section class="modal-card-body">
      <component :is="`${type}FavoritesPortal`" :content="resource" />
    </section>

    <footer class="modal-card-foot" style="justify-content: flex-end;">
      <div class="buttons modal-buttons">
        <b-button class="is-white" size="is-large" @click="close"
          >Cancel</b-button
        >
        <b-button
          class="is-success"
          size="is-large"
          @click="submit"
          :disabled="inCollection || loading || !$can($A.POST, $R.FAVORITES)"
          :loading="loading"
          >{{ inCollection ? "In Collection" : "Add to Favorites" }}</b-button
        >
      </div>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CHECK_AUTH } from "@/store/actions.type";
import { showToast } from "@/common/toast.service.js";
import { resourceModules } from "@/common/resources/index.js";
import * as FavoritesPortals from "@/components/favorites/new/";
import { capitalize } from "lodash";

export default {
  components: { ...FavoritesPortals.default },
  methods: {
    async setInfo() {
      this.resource = (
        await resourceModules[this.$attrs.type].byID(this.$attrs.resourceID)
      ).data;
      this.inCollection = await this.resource.$inCollection();
    },
    close() {
      this.$emit("close");
    },
    submit() {
      this.loading = true;
      new resourceModules.favorites({
        targetIndex: this.$attrs.type,
        targetID: this.resource.id,
      })
        .$create()
        .then(() => {
          // Give check_auth a buffer after adding the favorite to the user
          setTimeout(async () => {
            showToast(`Successfully added.`, "is-success");
            await this.$store.dispatch(CHECK_AUTH);
            this.loading = false;
            this.close();
          }, 100);
        })
        .catch(err => {
          showToast(err.description, "is-danger");
          this.loading = false;
        });
    },
  },
  data() {
    return {
      resource: undefined,
      inCollection: false,
      loading: false,
      type: capitalize(this.$attrs.type),
    };
  },
  watch: {
    currentUser: {
      handler() {
        this.setInfo();
      },
      deep: true,
    },
  },
  async created() {
    this.setInfo();
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
};
</script>

<style scoped lang="scss"></style>
